import React from 'react';
import MenuList from './menuList';
import Wrapper from '../_Wrapper';

const MenuPage = _ => {
    return <Wrapper>
        <MenuList />
    </Wrapper>
}


export default MenuPage;